import { CompassRose, RhumbLines } from '@brig/theme/ornaments';
import { button, paper } from '@brig/theme/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Cartouche } from '@brig/theme/components';
import { useDocumentTitle } from '../useDocumentTitle.ts';
import * as styles from './NotFound.css.ts';

export function NotFound() {
  const { t } = useTranslation();
  useDocumentTitle(t('notFound.pageTitle'));
  return (
    <main className={styles.sea}>
      <RhumbLines originX={0.5} originY={0.5} opacity={0.12} />
      <section className={`${paper} ${styles.sheet}`}>
        <CompassRose size={120} className={styles.rose} northLabel="?" />
        <Cartouche kicker="404">{t('notFound.title')}</Cartouche>
        <p className={styles.body}>{t('notFound.body')}</p>
        <Link to="/" className={button({ tone: 'seal' })}>
          {t('notFound.back')}
        </Link>
      </section>
    </main>
  );
}
